import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./title-about.${locale}.json`));
